import 'styled-components/macro';
import 'scroll-shadow-element';
import { useSearchParams } from 'react-router-dom-v5-compat';
import { styled } from 'twin.macro';

import {
  AssignmentMarkdown,
  AssignmentMarkdownProps,
} from 'component-lib/molecules/assignment-markdown/AssignmentMarkdown';
import { useFeatureFlag } from 'core/molecules/feature-flag-manager/FeatureFlagManager';
import { ShadowScrollContainer } from 'play/molecules/shadow-scroll-container/ShadowScrollContainer';
import { AssignmentChecksCreationMode } from 'play/organisms/assignment-checks-creation-mode/AssignmentChecksCreationMode';
import { QueryParams } from 'support/QueryParams';
import { ChallengeTabType, LearnEnvironmentQuery } from 'types/graphql';

const ColoredContainer = styled.div`
  background-color: #3b4558;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface Props {
  challenge: NonNullable<LearnEnvironmentQuery['challenge']>;
  onAccordionToggle: AssignmentMarkdownProps['onToggle'];
}

export const AssignmentContent = ({ challenge, onAccordionToggle }: Props) => {
  const [hasChecksCreationFlag] = useFeatureFlag('feature_create_checks');
  const [search] = useSearchParams();
  const isChecksCreationMode = !!search.get(QueryParams.CHECKS_CREATION_MODE);
  const hasVirtualBrowserTab = challenge.tabs.some(tab => tab.type === ChallengeTabType.Browser);

  const showChecksCreationButton = hasChecksCreationFlag && isChecksCreationMode && hasVirtualBrowserTab;

  return (
    <ColoredContainer>
      {showChecksCreationButton ? (
        <AssignmentChecksCreationMode challenge={challenge} onAccordionToggle={onAccordionToggle} />
      ) : (
        <ShadowScrollContainer>
          <AssignmentMarkdown title={challenge.title} value={challenge.assignment} onToggle={onAccordionToggle} />
        </ShadowScrollContainer>
      )}
    </ColoredContainer>
  );
};
